import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import MuurikkaVideoPopup from '../Muurikka/MuurikkaVideoPopup';
import { isMuurikka } from "./MiscellaneousMenu";

const CarouselSettings = {
    showStatus: false,
    showThumbs: false,
    infiniteLoop: true,
};
const Slider = ({ values }) => {

    document.addEventListener('DOMContentLoaded', () => {
        const sliderDots = document.querySelector('.control-dots');
        const sliderLength = document.querySelectorAll('.slide');
        
        if (sliderLength.length === 1) {
            sliderDots.classList.add('slider-dots--hidden');
        } 
    });
      

    return (
        <>
            <Carousel {...CarouselSettings}>
                {values.map((value, index) =>
                    <a className="slider__link" href={value.url} key={`figure${index}`}>
                        <img className="slider__image" src={value.image}/>
                        <h2 className="slider__text">{value.text}</h2>
                    </a>
                )}
            </Carousel>
            {isMuurikka &&
                <MuurikkaVideoPopup />
            }
        </>

    )
}

export default Slider;
